import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './pc-container.css.lit';

/**
 * Container component
 * @element pc-container
 * @slot - This element has a default slot
 */
@customElement('pc-container')
export class PCContainer extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  @property({ type: Boolean, reflect: true })
  isHidden: boolean;

  @property({ type: Boolean, reflect: true, attribute: 'full-bleed' })
  fullBleed: boolean;

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-container': PCContainer;
  }
}
